import { Platform } from "react-native";
import type { OrderHistorySummary } from "../../cartTypes";
import type { FloatingPanelState } from "./types";

export const webCursorPointer = Platform.OS === "web" ? ({ cursor: "pointer" } as any) : null;
export const STORAGE_KEY = "cartHistoryFloatingPanel";

export const getOrderCardTotal = ({
  order,
  showDiscountPrices,
}: {
  order: OrderHistorySummary;
  showDiscountPrices: boolean;
}) => {
  if (showDiscountPrices) {
    return order.saved_opt_total > 0 ? order.saved_opt_total : order.saved_rrc_total;
  }

  return order.saved_rrc_total > 0 ? order.saved_rrc_total : order.total_price;
};

export const clamp = (value: number, min: number, max: number) => {
  if (value < min) return min;
  if (value > max) return max;
  return value;
};

export const createDefaultState = ({
  viewportWidth,
  viewportHeight,
  scaleAll,
}: {
  viewportWidth: number;
  viewportHeight: number;
  scaleAll: number;
}): FloatingPanelState => {
  const width = Math.min(Math.max(320 * scaleAll, 320), viewportWidth - 48 * scaleAll);
  const height = Math.min(Math.max(420 * scaleAll, 360), viewportHeight - 160 * scaleAll);

  return {
    x: Math.max(24 * scaleAll, viewportWidth - width - 24 * scaleAll),
    y: 120 * scaleAll,
    width,
    height,
    collapsed: false,
  };
};
